import { API_SERVICE_DOMAIN } from './serviceConstant';

export const CHANNEL = 'B2CNLR';
export const INDIA_WEBSITE_VALUE = 'IN';
export const US_WEBSITE_VALUE = 'US';
export const AE_WEBSITE_VALUE = 'AE';

export const INDIA_CURRENCY_CODE = 'INR';
export const DOM_COUNTRY_NAME = 'India';
export const US_CURRENCY_CODE = 'USD';
export const AE_CURRENCY_CODE = 'AED';

export const INDIA_LANGUAGE_VALUE = 'en-IN';
export const US_LANGUAGE_VALUE = 'en-US';
export const USER_TYPE_AGENT = 'AGENT';
export const GOOGLE_MAP_API_KEY = 'AIzaSyBJU4uwaQoXmdcAE7opwszx1kMpDLQr7_c';
export const GOOGLE_MAP_URL = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAP_API_KEY}&v=3.exp&libraries=geometry,drawing,places`;
export const HOLIDAYS_SERVICES_URL = '//holidayservice.makemytrip.com/HolidayServices/service/';

export const PACKAGE_BASE_PATH = '/holidays/india/package';
export const LISTING_BASE_PATH = '/holidays/india/search';

export const IMAGE_CDN_BASE_PATH = '//imgak.mmtcdn.com/hp-images/';
export const HOLIDAYS_IMG_CDN_PATH = '//imgak.mmtcdn.com/holidays/node/images/';

// export const IMAGE_CDN_BASE_PATH = `${MMT_HLD.imghpCDN}`;
// export const HOLIDAYS_IMG_CDN_PATH = `${MMT_HLD.imgCDN}/images/`;

export const LISTING_IMG_CDN_PATH = `${HOLIDAYS_IMG_CDN_PATH}listing/`;
export const DETAILSV2_IMG_CDN_PATH = `${HOLIDAYS_IMG_CDN_PATH}dynamicDetails/`;
export const REVIEW_IMG_CDN_PATH = `${HOLIDAYS_IMG_CDN_PATH}dynamicReview/`;
export const COMMON_IMG_CDN_PATH = `${HOLIDAYS_IMG_CDN_PATH}common/`;
export const MYRACHAT_IMG_CDN_PATH = `${HOLIDAYS_IMG_CDN_PATH}chat/`;
export const THANKYOU_IMG_CDN_PATH = `${HOLIDAYS_IMG_CDN_PATH}thankYou/`;
export const MAP_IMG_CDN_PATH = `${HOLIDAYS_IMG_CDN_PATH}map/`;

// export const IMG_CDN_PATH = '//imgak.mmtcdn.com/holidays/images/listing';

export const DEFAULT_PACKAGE_IMAGE = `${LISTING_IMG_CDN_PATH}defaultImg.png`;
export const EMI_ICON = `${LISTING_IMG_CDN_PATH}EMI.png`;
export const BANNER_CUSTOM_IMAGE = `${LISTING_IMG_CDN_PATH}customizedIcon.png`;
export const SME_DEFAULT_IMAGE = `${LISTING_IMG_CDN_PATH}SMEDefaultProfile.png`;
export const DEFAULT_BANNER_IMAGE = `${LISTING_IMG_CDN_PATH}defaultBannerImage.png`;

// Seller Screen Images
export const SELLER_SEARCH_ICON = `${LISTING_IMG_CDN_PATH}searchIcon.png`;
export const FLIGHT_ICON = `${LISTING_IMG_CDN_PATH}flightIcon.png`;
export const HOTEL_ICON = `${LISTING_IMG_CDN_PATH}hotel.png`;
export const CAB_ICON = `${LISTING_IMG_CDN_PATH}cab.png`;
export const NO_FLIGHT_ERROR_ICON = `${LISTING_IMG_CDN_PATH}noFlightError.png`;
export const CROSS_ICON = `${LISTING_IMG_CDN_PATH}cross.png`;

// Seller Screen Constants
export const REVIEW_PAGE_VISITED = 'REVIEW PAGE VISITED';
export const PAYMENT_PAGE_VISITED = 'PAYMENT PAGE VISITED';
export const SME_BASE_PATH = '/holidays/sme';

// Page Constants
export const LISTING_V2_PAGE = 'LISTING_V2_PAGE';
export const SME_DETAILS_PAGE = 'SME_DETAILS_PAGE';
export const COLLECTIONS_PAGE_NAME = 'collections';
export const COLLECTION_PAGE_NAME = 'COLLECTION';
export const LISTING_PAGE_NAME = 'listing';

export const SME_ERROR_IMAGE = `${LISTING_IMG_CDN_PATH}img-error-ghost.png`;

export const ERROR_TOO_MANY_FILTER_IMAGE =
  'https://jsak.mmtcdn.com/holidays/node/images/common/filter.png';
export const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const AGENT_INFO = 'agentInfo';
export const HOLIDAYS_WEBSITE_URL = 'https://holidayz.makemytrip.com';
export const MAKEMYTRIP_WEBSITE_URL = 'https://www.makemytrip.com';
export const URL_PARAMS = {
  DROP_OFF: 'DROP_OFF',
};
export const AFFILIATES = {
  MMT: 'MMT',
  GOIBIBO: 'GI',
  INDIGO: 'IGO',
  MY_PARTNER: 'MYP',
  HDFC_SB: 'HDFC_SB',
  AIX: 'AFFCGOBIZMMTAIX',
  HE_AGENT: 'AFFCGOBIZMMTFLTEXP', // Holiday Expert Agent
};

export const AFFILIATE_CONFIG = {
  [AFFILIATES.MMT]: {
    affiliateIdentifier: AFFILIATES.MMT,
    affiliateName: 'Makemytrip',
    apiUrl: API_SERVICE_DOMAIN,
    assetUrl: '',
    baseUrl: 'https://holidayz.makemytrip.com',
    authCookieKey: 'mmt-auth',
    gtmId: 'AW-1044434772',
    authCookieDomain: '.makemytrip.com',
    myraTenantId: '0',
  },
  [AFFILIATES.GOIBIBO]: {
    affiliateIdentifier: AFFILIATES.GOIBIBO,
    affiliateName: 'Goibibo',
    apiUrl: API_SERVICE_DOMAIN,
    assetUrl: '',
    baseUrl: 'https://giholidays.makemytrip.com',
    authCookieKey: 'mmt-auth-gi',
    gtmId: 'GTM-PHR9S8W',
    authCookieDomain: '.giholidays.makemytrip.com',
    myraTenantId: '1',
  },
  [AFFILIATES.INDIGO]: {
    affiliateIdentifier: AFFILIATES.INDIGO,
    affiliateName: 'Indigo',
    apiUrl: '//holidayservice.makemytrip.com/HolidayServices/service',
    assetUrl: '',
    baseUrl: 'https://6eholidays.makemytrip.com',
    authCookieKey: 'mmt-auth-igo',
    gtmId: 'AW-1044434772',
    authCookieDomain: '.6eholidays.makemytrip.com',
    myraTenantId: '2',
  },
  [AFFILIATES.HDFC_SB]: {
    affiliateIdentifier: AFFILIATES.HDFC_SB,
    affiliateName: 'Hdfc',
    apiUrl: '//holidayservice.makemytrip.com/HolidayServices/service',
    assetUrl: '',
    baseUrl: 'https://hdfcsmartbuyholidays.makemytrip.com',
    authCookieKey: 'mmt-auth-hdfc_sb',
    gtmId: 'AW-1044434772',
    authCookieDomain: '.hdfcsmartbuyholidays.makemytrip.com',
    myraTenantId: '4',
  },
  [AFFILIATES.AIX]: {
    affiliateIdentifier: AFFILIATES.AIX,
    affiliateName: 'Aix',
    apiUrl: '//holidayservice.makemytrip.com/HolidayServices/service',
    assetUrl: '',
    baseUrl: 'https://airindiaexpressholidays.makemytrip.com',
    authCookieKey: 'mmt-auth-affcgobizmmtaix',
    gtmId: 'AW-1044434772',
    authCookieDomain: '.airindiaexpressholidays.makemytrip.com',
    myraTenantId: '8',
  },
  [AFFILIATES.HE_AGENT]: {
    affiliateIdentifier: AFFILIATES.MMT,
    affiliateName: 'Makemytrip',
    apiUrl: API_SERVICE_DOMAIN,
    assetUrl: '',
    baseUrl: 'https://holidaysexpert.makemytrip.com',
    authCookieKey: 'mmt-auth-affcgobizmmtfltexp',
    gtmId: 'AW-1044434772',
    authCookieDomain: '.makemytrip.com',
    myraTenantId: '0',
  },
};
export const DEFAULT_DEPARTURE_CITY = 'New Delhi';
export const DEFAULT_DEPARTURE_CODE = 'CTDEL';
export const DEFAULT_DEPARTURE_CITY_TYPE = 'CITY';
export const DEFAULT_PAGE_ERROR = 'Something went wrong! Please try again later.';

export const BRANCHES = {
  DOM: 'DOM',
  OBT: 'OBT',
};

export const COMPARE_IDS_DELIMETER = '__';
export const COMPARE_PAGE_PATH = '/holidays/psm/quotes/compare';
export const PERSUASIONV2_SECTION_CODE = 'PRS';
export const IGOS = 'IGOS';
export const MMT_BLACK = 'MMT_BLACK';
export const PRICE_PERSUASION = 'PRICE';

export const CTA_DEFAULT_TEXT = {
  GET_A_CALLBACK: 'Get a callback',
  FIND_A_BRANCH: 'Find a branch',
  LIVE_CHAT: 'Live Chat',
  FALLBACK_TEXT: 'Need Help?',
  CALL_US: 'Call Us',
};

export const FILTER_VIEW_TYPE = {
  UI: 'ui',
  GUIDED: 'guided',
};

export const PRESALES_ERROR_CODE = {
  PRESALES_ERROR_021: 'PreSalesError021',
  CANCEL_BTN_TEXT: 'NO, NOT NOW',
  CHANGE_BTN_TEXT: 'YES, GO AHEAD',
};

export const HOLIDAYS_LANDING_PAGE = 'https://www.makemytrip.com/holidays-india/';

export const PROPERTY = 'PROPERTY';

export const CHAT_GPT_VALUES_ARRAY = ['chatgpt_shown', 'chatgpt_click', 'chatgpt_close'];

export const LIVE_CHAT_COOKIE_KEY = 'LiveChatCookie';

export const TAB_LIST = {
  ANNOUNCEMENTS: 'Announcements',
  OFFERS: 'Offers',
  RECKONERS: 'Reckoners',
  MY_OFFERS: 'My Offers',
};

export const BASE_CARD_TYPE = {
  FLIGHT: 'FLIGHT',
  CAR_SIGHTSEEING: 'SIGHTSEEING',
  MEAL_STRIP: 'MEAL',
  TRANSFER: 'TRANSFER',
};

export const PAGENAME_LIST = {
  LISTINGV3: 'listingV3',
  DETAILSV2: 'detailsV2',
  DETAILSV3: 'detailsV3',
  PRESALES: 'presales',
  REVIEW: 'reviewV3',
  ONLY_REVIEW: 'review',
};
